<div class="mat-elevation-z8 ccorbit-mat-table col-settings-wrapper" [cdkContextMenuTriggerFor]="context_menu2">

  <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
       [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
      <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
    </div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column2 of tableColumnsOrdenes">
        <mat-checkbox [checked]="column2.isShow" (change)="toggleColumnVisibilityOrdenes(column2.id)" [color]="'primary'">
          {{column2.name}}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="compact-checkboxes">
    <button mat-icon-button class="compact-icon" [class.active]="verAbiertos"
            (click)="verAbiertos = !verAbiertos; refrescarTabla()" matTooltip="Pares abiertos">
      <mat-icon>lock_open</mat-icon>
    </button>
    <button mat-icon-button class="compact-icon" [class.active]="verCerrados"
            (click)="verCerrados = !verCerrados; refrescarTabla()" matTooltip="Pares cerrados">
      <mat-icon>lock</mat-icon>
    </button>
  </div>

  <cdk-virtual-scroll-viewport #ordenesView item [appendOnly]="false"
    [tvsItemSize]="24" [headerHeight]="34" class="wrapperBroker mat-elevation-z2 tableStyle" [style.height]="alto">
    <table cdk-table [dataSource]="ListaOrdenes" class="table-striped tableStyle">

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsOrdenes; sticky: true" class="sticky-header"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsOrdenes;" (click)="selectRowCartera(row)"
        [ngClass]="{'selected': isSelected(row), 'en-cola': row.enCola}" (contextmenu)="mostrarMenu($event, row)"></tr>
      <ng-container *ngFor="let tablecol of tableColumnsOrdenes">

        <ng-container [cdkColumnDef]="tablecol.id">
          <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header" (click)="tablecol.id === 'lastExecutionTime' ? orderBy('lastExecutionTime') :
                                                                                  tablecol.id === 'ticker' ? orderBy('ticker') :
                                                                                (tablecol.id === 'status' ? orderBy('status') : null)">
            {{tablecol.name}}
          </th>
          <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA' ,
                                                            'entrada': item[tablecol.id] === 'ENTRADA',
                                                            'numero-positivo': item[tablecol.id] > 0 || item[tablecol.id] === 'Filled',
                                                            'numero-negativo': item[tablecol.id] < 0,
                                                            'cancelled-status': item[tablecol.id] === 'Cancelled',
                                                            'pendiente-status': item[tablecol.id] === 'Submitted' || item[tablecol.id] === 'PreSubmitted' || item[tablecol.id] === 'En cola'
                                                            }">
            <ng-container *ngIf="tablecol.isString &&  tablecol.id !== 'hora' && tablecol.id !== 'horaCotizacion' && tablecol.id !== 'lastExecutionTime_r' && tablecol.id !== 'fechaRegistro' && tablecol.id !== 'fechaActualizacion' && tablecol.id !== 'origen'" >
              {{item[tablecol.id]}}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'origen'">{{item.origen | origenOrden}}</ng-container>
            <ng-container *ngIf="tablecol.isDate">
              {{item[tablecol.id] | smartDate }}
            </ng-container>
            <ng-container *ngIf="tablecol.isNumber">
              {{item[tablecol.id] |number:'1.2-2'}}
              <span *ngIf="controlOperativa && tablecol.id === 'price' && slSubido(item) as op" class="sl-subido"
                [matTooltip]="'SL dinámico: ' + sltp.formatPrice(op.stoploss, op) + (op.carterastoplossdinamicoactivo ? ' (D)' : ' (S)')">
                {{ op.bajista ? '↓' : '↑' }}
              </span>
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'hora'">
              {{ formatHoraCotizacion(item['hora'])}}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'horaCotizacion'">
              {{ formatHoraCotizacion(item['horaCotizacion'])}}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'fechaRegistro'">
              {{ formatFechaHoraCotizacion(item['fechaRegistro']) }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'lastExecutionTime_r'">
              {{ formatFechaHoraCotizacion(item['lastExecutionTime_r']) }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'fechaActualizacion'">
              {{ formatFechaHoraCotizacion(item['fechaActualizacion']) }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'modelo'">
              {{ item['modelo'].split('-')[1] }}
            </ng-container>
            <ng-container *ngIf="tablecol.id === 'cartera'">
              {{ item['modelo'].split('-')[0] }}
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>
</div>

<ng-template #context_menu2 let-data="data">
  <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
    <button class="example-menu-item" (click)="CancelarOrden()" cdkMenuItem>
      <mat-icon class="menu-icon">cancel</mat-icon>
      <span>Cancelar</span>
    </button>
    <button class="example-menu-item" (click)="CancelarTodasOrden()" cdkMenuItem>
      <mat-icon class="menu-icon">cancel</mat-icon>
      <span>Cancelar Todas las ordenes</span>
    </button>
    <button class="example-menu-item" (click)="EliminarOrden()" cdkMenuItem>
      <mat-icon class="menu-icon">delete</mat-icon>
      <span>Eliminar</span>
    </button>
    <button class="example-menu-item" (click)="editarOrden()" cdkMenuItem>
      <mat-icon class="menu-icon">edit</mat-icon>
      <span>Editar</span>
    </button>
  </div>
</ng-template>
